import defaults_translation from './../common/translation';

export default (part, lang = defaults_translation.lang) => {
  const path = `./${lang}/`;

  return require(`${path}${part}.json`);
};
